import { useState, useEffect } from "react";

// react-router components
import { useLocation, Link } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @material-ui core components
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import Breadcrumbs from "examples/Breadcrumbs";
import NotificationItem from "examples/Items/NotificationItem";


// Custom styles for DashboardNavbar
import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
} from "examples/Navbars/DashboardNavbar/styles";

// Material Dashboard 2 React context
import {
  useMaterialUIController,
  setTransparentNavbar,
} from "context";
import MDTypography from "components/MDTypography";
import { Box } from "@mui/material";
import colors from "assets/theme/base/colors";

function DashboardNavbar({ absolute, light, isMini }) {
  const [navbarType, setNavbarType] = useState();
  const [showName,setShowName]=useState(null);
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, transparentNavbar, fixedNavbar, openConfigurator, darkMode } = controller;
  const [anchorEl, setAnchorEl] = useState(null); // Initialize anchorEl for the menu
  const route = useLocation().pathname.split("/").slice(1);

  useEffect(() => {
    let email = localStorage.getItem('email')
    setShowName(email)

    // Setting the navbar type
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
    }

    /** 
     The event listener that's calling the handleTransparentNavbar function when 
     scrolling the window.
    */
    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleLogout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('email');
    window.location.href = '/sign-in';
  }

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget); // Set anchorEl to the current target (IconButton)
  };

  const handleMenuClose = () => {
    setAnchorEl(null); // Close the menu
  };


  return (
    <AppBar
      position={absolute ? "absolute" : navbarType}
      color="inherit"
      sx={(theme) => navbar(theme, { transparentNavbar, absolute, light, darkMode })}
    >
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        <MDBox color="inherit" mb={{ xs: 1, md: 0 }} sx={(theme) => navbarRow(theme, { isMini })}>
          <Breadcrumbs icon="home" title={route[route.length - 1]} route={route} light={light} />
        </MDBox>
        {isMini ? null : (
          <MDBox sx={(theme) => navbarRow(theme, { isMini })}>
            {
              showName ? (
                <MDBox mr={1}>
                  <MDTypography variant="button" fontWeight="medium" color={light ? "white" : "dark"}>
                    {showName}
                  </MDTypography>
                </MDBox>
              ) : null
            }
            <MDBox color={light ? "white" : "inherit"}>
              {/* <IconButton
                sx={navbarIconButton}
                size="small"
                disableRipple
                onClick={handleMenuOpen} // Open the menu on click
              >
                <Icon sx={{ color: light || darkMode ? "white" : "inherit" }}>account_circle</Icon>
              </IconButton> */}
              <IconButton
  sx={navbarIconButton}
  size="small"
  disableRipple
  onClick={handleMenuOpen}
>
  {showName ? (
    <Box
       sx={{
        bgcolor: colors?.badgeColors?.info?.text,
        color:  colors?.gradients?.light?.main,
        fontSize: 30,
        width: 40,
        height: 40,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textTransform: "uppercase",}}
    >
      {showName.charAt(0)}
    </Box>
  ) : (
    <Icon sx={{ color: light || darkMode ? "white" : "inherit" }}>
      account_circle
    </Icon>
  )}
</IconButton>

              {/* Dropdown Menu */}
              <Menu
                anchorEl={anchorEl} // Use anchorEl to control the position of the menu
                open={Boolean(anchorEl)} // Menu is open if anchorEl is not null
                onClose={handleMenuClose} // Close the menu when clicked outside
              >
                <MenuItem onClick={handleLogout}>Logout</MenuItem>
              </Menu>
            </MDBox>
          </MDBox>
        )}
      </Toolbar>
    </AppBar>
  );
}

// Setting default values for the props of DashboardNavbar
DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
